import { PageTypeSuffix } from '@/constants'
import { type Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface BlogCardType {
  post: Post
  className?: string
  feature?: boolean
  idx?: number
  onClick?: () => void
}

export const BlogCardV1 = ({ post, className = '', idx = 0 }: BlogCardType) => {
  return (
    <div className='w-full'>
      <div
        className={`h-full overflow-hidden rounded-lg ${className} ${
          idx == 0 ? 'bg-white' : 'bg-primary-base'
        }`}
      >
        <div className='grid h-full grid-cols-2 gap-1 py-3 pl-4 pr-2'>
          <div className='description flex flex-col gap-1.5'>
            <Link
              href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${
                PageTypeSuffix.POST
              }`}
              className='block'
            >
              <h3
                className={`text-sm font-medium leading-[17px] ${
                  idx == 0 ? 'text-dark-800' : 'text-white'
                }`}
              >
                {getTranslate(post?.title)}
              </h3>
            </Link>
            <Link
              href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${
                PageTypeSuffix.POST
              }`}
              className={`mt-2 flex h-9 w-max items-center justify-center rounded px-3 text-sm font-semibold ${
                idx == 0
                  ? 'bg-primary-base text-white'
                  : 'bg-white text-dark-900'
              }`}
            >
              Xem thêm
            </Link>
          </div>
          <div className='w-full'>
            <ImageOptimize
              src={post?.images[0]}
              className='h-full w-full object-contain'
              width={404}
              height={227}
              loading='lazy'
              alt={getTranslate(post?.title)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlogCardV1
